import React from "react";

const Footer = () => {
    return (
        <footer className="w-full py-10 px-6 md:px-12 lg:px-20 xl:px-32 bg-background border-t border-white/10 text-text-light">

            <div className="flex flex-col md:flex-row justify-between items-center gap-6">

                {/* COPYRIGHT TEXT */}
                <p className="text-text-light/60 text-sm">
                    © {new Date().getFullYear()} Design & Develop by Bhavya Kansara. All rights reserved.
                </p>

            </div>
        </footer>
    );
};

export default Footer;
